export default {
	DISMISS: 'Dismiss this notification',
};
